import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState
} from 'react';
import { images as fallbackImages } from '../data';
import { getLandingImages } from '../services/landingService';

const LandingImageContext = createContext(fallbackImages);

export function LandingImageProvider({ children }) {
  const [images, setImages] = useState(fallbackImages);

  useEffect(() => {
    let active = true;

    getLandingImages()
      .then((configuredImages) => {
        if (active) {
          setImages((current) => ({ ...current, ...configuredImages }));
        }
      })
      .catch(() => {
        // Keep verified local fallback URLs when settings are unavailable.
      });

    return () => {
      active = false;
    };
  }, []);

  const value = useMemo(() => images, [images]);

  return (
    <LandingImageContext.Provider value={value}>
      {children}
    </LandingImageContext.Provider>
  );
}

export function useLandingImages() {
  return useContext(LandingImageContext);
}